import React, { createContext, useContext, useEffect, useState } from "react";
import http from "@/lib/http";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("fn_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("fn_token");
    if (!token) { setLoading(false); return; }
    http.get("/api/auth/me")
      .then((r) => { setUser(r.data); localStorage.setItem("fn_user", JSON.stringify(r.data)); })
      .catch(() => { localStorage.removeItem("fn_token"); localStorage.removeItem("fn_user"); setUser(null); })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await http.post("/api/auth/login", { email, password });
    localStorage.setItem("fn_token", data.access_token);
    localStorage.setItem("fn_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("fn_token");
    localStorage.removeItem("fn_user");
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
